import './Badges.css';
import React from "react";
import dot from '../../assets/images/dot.png'
import whiteLine from '../../assets/images/whiteLine.png'

function Badges(props) {

    return (
        <div class="badges">
            <a href="https://www.oneoffourteen.com/" className="badgeGroup group1">
                <img className="lineImage" src={whiteLine} alt="white, thin long line"/>
                <img className="roundBadgeImage" src={dot} alt="white 3 dimensional circular badge with the one of fourteen logo inside"/>
                <p className="badgeTitleText"> one of fourteen </p>
            </a>
            <a href="/butter" className="badgeGroup group2">
                <img className="lineImage" src={whiteLine} alt="white, thin long line"/>
                <img className="roundBadgeImage" src={dot} alt="white 3 dimensional circular badge with the one of fourteen logo inside"/>
                <p className="badgeTitleText"> butter </p>
            </a>
            <a href="https://www.quit-sugar.com/" className="badgeGroup group3">
                <img className="lineImage" src={whiteLine} alt="white, thin long line"/>
                <img className="roundBadgeImage" src={dot} alt="white 3 dimensional circular badge with the one of fourteen logo inside"/>
                <p className="badgeTitleText"> sugar rehab</p>
            </a>
            <a href="https://socialmediaistoxic.com/" className="badgeGroup group4">
                <img className="lineImage" src={whiteLine} alt="white, thin long line"/>
                <img className="roundBadgeImage" src={dot} alt="white 3 dimensional circular badge with the one of fourteen logo inside"/>
                <p className="badgeTitleText"> nontoxic </p>
            </a>
        </div>
    )
}

export default Badges;